import { Dialog } from '@hub/common/Dialog/Dialog';
import { useTranslation } from 'next-i18next';
import { Sample } from '@hub/free-form-hub/common/uploadFile/Sample';

type SampleDialogProps = {
  visible: boolean;
  onClose: () => void;
  onLoadSampleModel: (formattedSampleNumber: string) => void;
};

export const SampleDialog = ({ visible, onClose, onLoadSampleModel }: SampleDialogProps) => {
  const { t } = useTranslation('free-form-hub/freeFormHubCommon');

  return (
    <Dialog
      visible={visible}
      closable
      onClose={() => {
        onClose();
      }}
    >
      <div className="p-6 md:p-24">
        <h2 className="absolute top-[1rem] xl:top-[2rem] text-md hidden lg:block">
          {t('HEADLINES.SAMPLE_MODELS', {
            ns: 'free-form-hub/freeFormHub',
          })}
        </h2>
        <Sample onLoadSampleModel={onLoadSampleModel} />
      </div>
    </Dialog>
  );
};
